const { createSlice } = require('@reduxjs/toolkit');

const currencySlice = createSlice({
    name: "currency",
    initialState: {
        currencySymbol: "₺",
        currencyName: "TL",
        currencyRate: 1
    },
    reducers: {
        // Para birimi değişikliği devre dışı - sadece TL kullanılacak
        setCurrency(state, action) {
            // Her zaman Türk Lirası döndür
            return {
                currencySymbol: "₺",
                currencyName: "TL",
                currencyRate: 1
            };
        }
    },
});

export const { setCurrency } = currencySlice.actions;
export default currencySlice.reducer;
